import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

export default class Employment extends Component{
	render(){
		let { props } = this
		return(
			<div style={{display: "flex", justifyContent: "space-between"}}>
				{
				R.map(employment => {
					return (
						<div className="employment" style={{width: "100%"}}>
							<h2 style={{color: "rgb(62, 208, 176)"}}>{employment.emplIter? "Prior employment" : "Current employment"}</h2>
							<div className="position" style={{display:!employment.positionTitle? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Position/Title:</span> {employment.positionTitle}</p>
							</div>
							<div className="years" style={{display:!employment.curEmplYears? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Full years of employment:</span> {employment.curEmplYears}</p>
							</div>
							<div className="monthly-income" style={{display:!employment.monIncome? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Gross monthly income:</span> {employment.monIncome}</p>
							</div>
							<div className="other-income" style={{display:!employment.otherIncome? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Other income (average per month):</span> {employment.otherIncome}</p>
							</div>
							<div className="other-income-spec" style={{display:!employment.otherSource? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Other income specification:</span> {employment.otherSource}</p>
							</div>
						</div>
					)
				})(props.data)
				}
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/applicationForm/Employment.js